import {useEffect, useState} from 'react';
import {PsFee} from '@application/PsFee';

export const useShouldPayPsFee = (): boolean => {
  const [shouldPay, setShouldPay] = useState<boolean>(true);

  useEffect(() => {
    PsFee.getInfo().then(({payPsFee}) => setShouldPay(payPsFee));
  }, []);

  return shouldPay;
};
